import { render, staticRenderFns } from "./primary-action-button.vue?vue&type=template&id=6c1c7134"
import script from "./primary-action-button.vue?vue&type=script&lang=js"
export * from "./primary-action-button.vue?vue&type=script&lang=js"
import style0 from "./primary-action-button.vue?vue&type=style&index=0&id=6c1c7134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports